<template>
    <FormSection :full-height="false" :application-id="application">
        <template #content>
            <section class="p-5 d-flex flex-column text-center text-primary" v-if="isSaveInProgress">
                <i class="far fa-save fa-7x me-2 animated slow flash infinite"></i>
                <div class="big-text mt-1">
                    <b>Save Family Health History in Progress...</b>
                </div>
            </section>
            <section class="row p-2 pb-0" v-if="!isSaveInProgress">
                <div class="form-group col-12 col-md-4">
                    <label for="health-condition">
                        Health Condition
                        <span class="text-danger">*</span>
                    </label>
                    <TypeaheadInput
                        ref="typeaheadInstance"
                        :getData="getHealthCondtionsList"
                        :value="selectedHealthCondition"
                        :init-value="selectedHealthCondition"
                        placeholder="Enter Health Condition"
                        :disabled="isEdit"
                        v-on:valueChanged="handleValueChange"
                        v-on:blurredInput="v$.familyHealthHistory.Condition.$touch"
                    />
                    <span v-if="v$.familyHealthHistory.Condition.$error" class="field-invalid"
                        >Health Condition is required.</span
                    >
                </div>
                <div class="col-12 row" v-for="(item, index) of familyHealthHistory.PatientRelations">
                    <div class="form-group col-md-3">
                        <label for="relationship-to-patient">
                            Relationship to Patient
                            <span class="text-danger">*</span>
                        </label>
                        <select
                            name="relationship-to-patient"
                            class="form-select"
                            v-model="item.RelationshipToPatient"
                            @blur="v$.familyHealthHistory.PatientRelations[index].RelationshipToPatient.$touch"
                        >
                            <option :value="null">Select Relationship to Patient</option>
                            <option v-for="(value, key) in patientRelationshipEnum" :value="value.value" :key="key">
                                {{ value.name }}
                            </option>
                        </select>
                        <span
                            v-if="v$.familyHealthHistory.PatientRelations[index].RelationshipToPatient.$error"
                            class="field-invalid"
                            >Relationship is required.</span
                        >
                    </div>
                    <div class="form-group col-md-3">
                        <label for="age-of-diagnosis"> Age of Diagnosis </label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="item.Age"
                            placeholder="Enter Age of Diagnosis"
                            :disabled="!item.RelationshipToPatient"
                            v-number-only
                        />
                    </div>
                    <div class="form-group col-md-3">
                        <label for="relation-status"> Status </label>
                        <select
                            name="relation-status"
                            class="form-select"
                            v-model="item.Status"
                            :disabled="!item.RelationshipToPatient"
                        >
                            <option :value="0">Select Status</option>
                            <option v-for="(value, key) of relationStatusEnum" :value="value.value">
                                {{ value.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-md-3">
                        <button
                            type="button"
                            class="btn btn-danger btn-sm mt-4"
                            @click="removeRelationship(index)"
                            v-if="familyHealthHistory.PatientRelations.length > 1"
                        >
                            Remove
                        </button>
                    </div>
                </div>
                <div class="col-12 pb-2">
                    <button type="button" class="btn btn-primary btn-sm ms-3" @click="addRelationship()">
                        Add Additional Relationship
                    </button>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./FamilyHealthHistoryForm.ts" />
